<h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Filtrér på periode for leveringsdato</h1>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>
<div mat-dialog-content>
  <form [formGroup]="form">
    <div class="form-row">
      <h2 class="form-headline margin--bottom-s align-center">Seneste...</h2>
      <div class="flex-wrap">
        <button mat-raised-button (click)="setRange('days')">Døgn</button>
        <button mat-raised-button (click)="setRange('weeks')">Uge</button>
        <button mat-raised-button (click)="setRange('months')">Måned</button>
        <button mat-raised-button (click)="setRange('years')">År</button>
      </div>
    </div>

    <div class="form-row flex">
      <div class="form-row form-row--inline">
        <mat-form-field appearance="outline">
          <mat-label>Fra:</mat-label>
          <input matInput [matDatepicker]="pickerFrom" formControlName="periodFrom" />
          <mat-datepicker-toggle matPrefix [for]="pickerFrom"></mat-datepicker-toggle>
          <mat-datepicker #pickerFrom></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="form-row form-row--inline">
        <mat-form-field appearance="outline">
          <mat-label>Til:</mat-label>
          <input matInput [matDatepicker]="pickerTo" formControlName="periodTo" />
          <mat-datepicker-toggle matPrefix [for]="pickerTo"></mat-datepicker-toggle>
          <mat-datepicker #pickerTo></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
  </form>
</div>
<div mat-dialog-actions class="row-reverse">
  <button mat-raised-button [mat-dialog-close]="{ periodFrom: null, periodTo: null }">Fjern periode</button>
  <button mat-raised-button color="primary" [mat-dialog-close]="form.value" [disabled]="!form.valid">Sæt periode</button>
</div>
